import { FC } from 'react';
import { DocumentDownloadIcon } from '../../../../../assets/svg/document-download';
import { ExternalLinkIcon } from '../../../../../assets/svg/external-link';
import { FilterIcon } from '../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../assets/svg/sort';
import { Checkbox } from '../../../../../components/checkbox/checkbox';
import { Dropdown } from '../../../../../components/dropdown/dropdown';
import { DropdownFilter } from '../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../features/dropdown-sorter/dropdown-sorter';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { ReviewsExportFormatType } from '../../../../../store/api/reviews-api';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useReviewsStore } from '../../../../../store/use-reviews-store';
import s from './reviews-controls.module.css';
import { DropdownStyleView } from '../../../../../features/dropdown-style-view/dropdown-style-view';

interface Props {
  onExport: (format: ReviewsExportFormatType) => void;
}

export const ReviewsControls: FC<Props> = ({ onExport }) => {
  const { reviews, loadingExportFormat } = useReviewsStore();
  const { place: branches } = useBranchesStore();

  const { t, getLocale } = useLang();
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const isWidgetExpanded = params.is_expanded === '1';

  const toggleWidgetExpand = () => {
    addQueryParams({ is_expanded: isWidgetExpanded ? undefined : '1' });
  };

  return (
    <div className={s.feature}>
      <Checkbox
        size="md"
        label={t('Развернуть виджет')}
        checked={isWidgetExpanded}
        onClick={toggleWidgetExpand}
      />
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала высокие оценки'), value: 'rating', dir: 'desc' },
          { label: t('Сначала низкие оценки'), value: 'rating', dir: 'asc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По дате'),
            value: 'created_at',
            filter: 'datetime-range',
          },
          {
            label: t('По оценке'),
            value: 'rating',
            filter: 'multi-select',
            filterOptions: [
              { id: '1', value: '1' },
              { id: '2', value: '2' },
              { id: '3', value: '3' },
              { id: '4', value: '4' },
              { id: '5', value: '5' },
            ],
          },
          {
            label: t('По филиалам'),
            value: 'place_id',
            filter: 'single-select',
            filterOptions: branches?.map((item) => ({
              id: String(item.id),
              value: getLocale(item.name),
            })),
          },
          {
            label: t('По авторам'),
            value: 'full_name',
            filter: 'input',
            suggestions: reviews?.map((item) => item.full_name),
          },
        ]}
      />
      <Dropdown
        label={t('Экспорт')}
        className="hide__M hide__S"
        leftIcon={<ExternalLinkIcon />}
        options={[
          {
            label: 'EXL',
            key: 'exl',
            content: <DocumentDownloadIcon />,
            isLoading: loadingExportFormat === 'excel',
            onClick: () => {
              onExport('excel');
            },
          },
          {
            label: 'PDF',
            key: 'pdf',
            content: <DocumentDownloadIcon />,
            isLoading: loadingExportFormat === 'pdf',
            onClick: () => onExport('pdf'),
          },
        ]}
      />
    </div>
  );
};
